(function () {
  const U = window.UIX;
  const APP = window.APP;
  const Match = window.RB.Match;
  const AX = window.RB.AnimKit;

  const el = U.el;
  const esc = U.esc;

  const PIPS = {
    1: [4],
    2: [0, 8],
    3: [0, 4, 8],
    4: [0, 2, 6, 8],
    5: [0, 2, 4, 6, 8],
    6: [0, 2, 3, 5, 6, 8],
  };

  const SLAM = { fall: 620, gap: 190, settle: 300 };
  const ROLL = { tumble: 900, tick: 70, hold: 620 };

  let gen = 0;

  function bump() {
    gen++;
    return gen;
  }

  function alive(token) {
    return token === gen && APP.screen === "pregame";
  }

  function flat() {
    return window.RB.Anim ? window.RB.Anim.flat() : false;
  }

  function speed() {
    const s = window.RB.Anim ? window.RB.Anim.speed : 1;
    return s > 0 ? s : 1;
  }

  function ms(v) {
    return flat() ? Math.min(180, Math.round(v / speed())) : Math.round(v / speed());
  }

  function play(node, frames, opts) {
    if (!node) return null;
    return AX.playRaw(node, frames, opts);
  }

  function humanSeat(m, p) {
    return !m.ai[p];
  }

  function localSeat(m) {
    if (m.online) return APP.seat || 0;
    for (let p = 0; p < 2; p++) if (humanSeat(m, p)) return p;
    return 0;
  }

  function seatName(m, p) {
    const reg = m.registered[p];
    return m.names[p] || ((reg && reg.name) || "Player " + (p + 1)).split(" — ")[0];
  }

  function fresh(m) {
    return {
      game: m.gameNo,
      phase: null,
      seat: localSeat(m),
      bf: null,
      sel: null,
      handoff: false,
      sent: false,
      note: null,
      revealed: false,
      rolled: false,
      decks: [null, null],
      busy: false,
    };
  }

  function ensure(m) {
    if (!APP.pregame || APP.pregame.game !== m.gameNo) APP.pregame = fresh(m);
    return APP.pregame;
  }

  function stageDeck(seat, live) {
    const m = APP.match;
    if (!m) return;
    const P = ensure(m);
    P.decks[seat] = live;
  }

  function presenter(m) {
    if (m.online) return APP.seat || 0;
    for (let p = 0; p < 2; p++) if (!m.pending.ready[p] && humanSeat(m, p)) return p;
    return null;
  }

  function needsSideboard(m, seat) {
    const P = ensure(m);
    return Match.canSideboard(m) && !P.decks[seat];
  }

  function start() {
    const m = APP.match;
    if (!m) { APP.screen = "menu"; U.render(); return; }
    ensure(m);
    step();
  }

  function step() {
    const m = APP.match;
    if (!m) { APP.screen = "menu"; U.render(); return; }
    if (m.over || !m.pending) { APP.screen = "match"; U.render(); return; }
    const P = ensure(m);
    APP.screen = "pregame";

    if (Match.phase(m) === "present") {
      if (!m.online) {
        for (let p = 0; p < 2; p++) {
          if (m.pending.ready[p] || humanSeat(m, p)) continue;
          Match.submit(m, p, Match.autoPresent(m, p));
        }
      }
    }

    if (Match.phase(m) === "present") {
      const seat = presenter(m);
      if (seat === null) { U.saveMatch(); U.render(); return; }
      if (needsSideboard(m, seat)) { U.openSideDeck(seat); return; }
      if (P.seat !== seat) {
        const both = !m.online && humanSeat(m, 0) && humanSeat(m, 1);
        P.seat = seat;
        P.bf = null;
        P.sel = null;
        P.sent = false;
        P.note = null;
        P.handoff = both && !P.decks[seat] && m.pending.ready[seat === 0 ? 1 : 0];
      }
      if (P.bf === null) P.bf = Match.bfChoices(m, seat)[0] || null;
      P.phase = "present";
      U.saveMatch();
      U.render();
      return;
    }

    const pd = m.pending;
    if (!P.revealed) {
      P.phase = "reveal";
      U.saveMatch();
      U.render();
      slam();
      return;
    }
    if (pd.roll && !P.rolled) {
      if (!m.online && !humanSeat(m, 0) && !humanSeat(m, 1)) {
        P.rolled = true;
        step();
        return;
      }
      P.phase = "roll";
      U.saveMatch();
      U.render();
      return;
    }
    if (pd.pick && pd.first === null) {
      if (!m.online && !humanSeat(m, pd.designated)) {
        Match.chooseFirst(m, pd.designated, Match.autoFirst(m));
        step();
        return;
      }
      P.phase = "first";
      U.saveMatch();
      U.render();
      return;
    }
    P.phase = "launch";
    U.saveMatch();
    U.render();
    if (m.online) return;
    launch();
  }

  function launch() {
    const m = APP.match;
    const P = ensure(m);
    if (P.busy) return;
    P.busy = true;
    const token = bump();
    setTimeout(function () {
      if (!alive(token) || !APP.match || !APP.match.pending) return;
      const setup = Match.buildSetup(APP.match);
      if (!setup) return;
      APP.pregame = null;
      U.saveMatch();
      U.newGame(setup);
      U.saveMatch();
    }, ms(560));
  }

  function submit() {
    const m = APP.match;
    const P = ensure(m);
    const choice = { bf: P.bf };
    if (Match.canSideboard(m) && P.decks[P.seat]) choice.deck = P.decks[P.seat];
    if (m.online) {
      const problem = Match.submitProblem(m, P.seat, choice);
      if (problem) { P.note = problem; U.render(); return; }
      P.sent = true;
      window.RB.Online.Game.sendPrep(choice);
      U.render();
      return;
    }
    const problem = Match.submit(m, P.seat, choice);
    if (problem) { P.note = problem; U.render(); return; }
    step();
  }

  function pickFirst(first) {
    const m = APP.match;
    if (m.online) { window.RB.Online.Game.sendFirst(first); return; }
    const problem = Match.chooseFirst(m, m.pending.designated, first);
    if (problem) { APP.error = problem; U.render(); return; }
    step();
  }

  function slam() {
    const m = APP.match;
    const P = ensure(m);
    const token = bump();
    const tiles = document.querySelectorAll("#arena .pgbf");
    const stage = document.querySelector("#arena .arfit");
    const fall = ms(SLAM.fall);
    const gap = ms(SLAM.gap);
    for (let i = 0; i < tiles.length; i++) {
      const tile = tiles[i];
      const tilt = i === 0 ? -7 : 6;
      const delay = i * gap;
      play(tile, [
        { transform: "translateY(-1250px) scale(1.65) rotate(" + tilt + "deg)", opacity: 0, offset: 0, easing: "cubic-bezier(.55,.03,.9,.35)" },
        { transform: "translateY(-90px) scale(1.09) rotate(" + (tilt * 0.24).toFixed(2) + "deg)", opacity: 1, offset: 0.74, easing: "ease-in" },
        { transform: "translateY(0) scaleX(1.06) scaleY(.84) rotate(0deg)", offset: 0.84, easing: AX.EASE.settle },
        { transform: "translateY(0) scaleX(.98) scaleY(1.03)", offset: 0.93, easing: AX.EASE.settle },
        { transform: "none", offset: 1 },
      ], { duration: fall, delay: delay, fill: "backwards" });
      const shock = el("div", "pgshock");
      tile.appendChild(shock);
      play(shock, [
        { transform: "scale(.35)", opacity: 0, offset: 0 },
        { transform: "scale(.4)", opacity: .85, offset: 0.01 },
        { transform: "scale(1.5)", opacity: 0, offset: 1 },
      ], { duration: ms(520), delay: delay + Math.round(fall * 0.8), fill: "backwards" });
      if (stage && !flat()) {
        play(stage, [
          { transform: "translate(0,0)" },
          { transform: "translate(3px,7px)", offset: 0.2 },
          { transform: "translate(-4px,-4px)", offset: 0.45 },
          { transform: "translate(2px,2px)", offset: 0.7 },
          { transform: "translate(0,0)" },
        ], { duration: ms(340), delay: delay + Math.round(fall * 0.8) });
      }
    }
    const total = fall + (tiles.length - 1) * gap + ms(SLAM.settle);
    setTimeout(function () {
      if (!alive(token) || !APP.match) return;
      const cur = ensure(APP.match);
      if (cur.revealed) return;
      cur.revealed = true;
      step();
    }, tiles.length ? total : 0);
  }

  function rollNow() {
    const m = APP.match;
    const P = ensure(m);
    if (P.busy || !m.pending || !m.pending.roll) return;
    P.busy = true;
    const token = bump();
    const dice = document.querySelectorAll("#arena .pgdie");
    const values = m.pending.roll.values;
    const tumble = ms(ROLL.tumble);
    for (let i = 0; i < dice.length; i++) {
      const die = dice[i];
      die.classList.add("rolling");
      play(die, [
        { transform: "translateY(0) rotate(0deg) scale(1)" },
        { transform: "translateY(-58px) rotate(190deg) scale(1.16)", offset: 0.3, easing: "ease-out" },
        { transform: "translateY(-22px) rotate(430deg) scale(1.08)", offset: 0.62, easing: "ease-in" },
        { transform: "translateY(6px) rotate(710deg) scale(.94)", offset: 0.86, easing: AX.EASE.settle },
        { transform: "translateY(0) rotate(720deg) scale(1)", offset: 1 },
      ], { duration: tumble, easing: "linear" });
    }
    const ticks = Math.max(1, Math.round(tumble / ms(ROLL.tick)));
    let n = 0;
    const spin = setInterval(function () {
      if (!alive(token)) { clearInterval(spin); return; }
      n++;
      for (let i = 0; i < dice.length; i++) {
        const face = 1 + Math.floor(Math.random() * 6);
        setFace(dice[i], n >= ticks ? values[i] : face);
      }
      if (n >= ticks) clearInterval(spin);
    }, ms(ROLL.tick));
    setTimeout(function () {
      if (!alive(token) || !APP.match) return;
      for (let i = 0; i < dice.length; i++) {
        setFace(dice[i], values[i]);
        dice[i].classList.remove("rolling");
        dice[i].classList.toggle("won", i === m.pending.roll.designated);
        if (i === m.pending.roll.designated) {
          play(dice[i], [
            { transform: "scale(1)" },
            { transform: "scale(1.22)", offset: 0.4, easing: AX.EASE.settle },
            { transform: "scale(1)" },
          ], { duration: ms(420) });
        }
      }
      setTimeout(function () {
        if (!alive(token) || !APP.match) return;
        const cur = ensure(APP.match);
        cur.rolled = true;
        cur.busy = false;
        step();
      }, ms(ROLL.hold));
    }, tumble);
  }

  function setFace(die, n) {
    const cells = die.querySelectorAll(".pgpip");
    const on = PIPS[n] || [];
    for (let i = 0; i < cells.length; i++) cells[i].classList.toggle("on", on.indexOf(i) >= 0);
    die.setAttribute("data-face", String(n));
  }

  function dieNode(m, p, value) {
    const die = el("div", "pgdie " + U.pcls(p));
    const face = el("div", "pgdieface");
    for (let i = 0; i < 9; i++) face.appendChild(el("span", "pgpip"));
    die.appendChild(face);
    die.title = seatName(m, p) + "'s die";
    setFace(die, value || 1);
    return die;
  }

  function fieldTile(m, p, id, opts) {
    const o = opts || {};
    const card = id ? window.RB.Setup.findCard(id) : null;
    const tile = el("div", "arbf pgbf " + U.pcls(p) + (o.hidden ? " pghidden" : ""));
    if (card && !o.hidden) {
      const art = el("div", "arbfart");
      U.artStyleCard(art, card, "bf", 1400);
      tile.appendChild(art);
    }
    tile.appendChild(el("div", "arbfveil"));
    tile.appendChild(el("div", "arbfedge"));
    tile.appendChild(el("div", "arbfline"));
    if (o.hidden) {
      const back = el("div", "pgbfback", U.backSvg(30));
      tile.appendChild(back);
    } else if (card) {
      tile.appendChild(el("div", "arbfname", esc(card.name)));
      tile.appendChild(el("div", "arbftext", U.fmtText(U.stripReminder(card.text))));
    }
    const who = el("div", "pgbfwho " + U.pcls(p), esc(seatName(m, p) + " presents"));
    tile.appendChild(who);
    return tile;
  }

  function statusLine(m, P) {
    const pd = m.pending;
    if (P.phase === "present") {
      return P.sent ? "Waiting for " + seatName(m, P.seat === 0 ? 1 : 0)
        : "Present a battlefield";
    }
    if (P.phase === "reveal") return "Battlefields placed";
    if (P.phase === "roll") return "Roll for the first player";
    if (P.phase === "first") {
      return chooserIsHere(m) ? "Play or draw" : "Waiting for " + seatName(m, pd.designated);
    }
    return "The duel begins";
  }

  function ruleLine(m, P) {
    const pd = m.pending;
    if (P.phase === "present") {
      return Match.isMatch(m)
        ? "Both battlefields are placed at the same time, so neither seat sees the other's first (CR 486.5)."
        : "A duel draws each battlefield at random (CR 485.5).";
    }
    if (P.phase === "reveal") return "Battlefields are placed before the turn order is settled (CR 113, CR 115).";
    if (P.phase === "roll") {
      return Match.isMatch(m)
        ? "The higher roll is designated and chooses to play or draw (TR 407.2)."
        : "The higher roll takes the first turn (CR 115).";
    }
    if (P.phase === "first") {
      if (!pd.roll) return seatName(m, pd.designated) + " lost game " + (m.gameNo - 1) + " and chooses (TR 407.4).";
      return "The player going second channels an extra rune on their first channel phase (CR 485.7).";
    }
    return null;
  }

  function dial(m, P) {
    const pd = m.pending;
    const box = el("div", "ardialbox pgdial");
    if (P.phase === "roll" || (pd.roll && P.rolled)) {
      const tray = el("div", "pgdice");
      for (let p = 0; p < 2; p++) {
        const cell = el("div", "pgdicecell");
        cell.appendChild(el("div", "zlabel", esc(seatName(m, p))));
        cell.appendChild(dieNode(m, p, pd.roll ? pd.roll.values[p] : 1));
        tray.appendChild(cell);
      }
      box.appendChild(tray);
      if (P.phase === "roll") {
        const go = el("button", "btn primary pgroll", "Roll the dice");
        go.disabled = !!P.busy;
        go.onclick = function () { rollNow(); };
        box.appendChild(go);
      }
    } else {
      const crest = el("div", "pgcrest");
      crest.appendChild(el("div", "pgcrestnum", Match.isMatch(m) ? "G" + m.gameNo : "VS"));
      box.appendChild(crest);
    }
    box.appendChild(el("div", "arstatus", esc(statusLine(m, P))));
    return box;
  }

  function selector(m, P) {
    const tray = el("div", "pgtray");
    const choices = Match.bfChoices(m, P.seat);
    const head = el("div", "pghead");
    head.appendChild(el("span", "mslbl", "Your battlefields"));
    head.appendChild(el("span", "msnum", choices.length + " available"));
    tray.appendChild(head);
    const row = el("div", "pgpick");
    for (const id of m.registered[P.seat].battlefields || []) {
      (function (id) {
        const card = window.RB.Setup.findCard(id);
        const open = choices.indexOf(id) >= 0;
        const tile = el("div", "pgopt" + (P.bf === id ? " sel" : "") + (open ? "" : " dim"));
        const art = el("div", "pgoptart");
        if (card) U.artStyleCard(art, card, "bf", 700);
        tile.appendChild(art);
        tile.appendChild(el("div", "pgoptveil"));
        tile.appendChild(el("div", "pgoptname", esc(card ? card.name : id)));
        if (!open) tile.appendChild(el("div", "pgoptused", "USED"));
        tile.title = open ? (card ? card.name : id) : "Already presented this match (CR 486.5)";
        tile.onclick = function () {
          P.sel = id;
          if (open) { P.bf = id; P.note = null; }
          U.render();
        };
        row.appendChild(tile);
      })(id);
    }
    tray.appendChild(row);
    const foot = el("div", "pgfoot");
    if (P.note) foot.appendChild(el("div", "msgonote bad", esc(P.note)));
    const go = el("button", "btn primary big", "Present it");
    go.disabled = !P.bf || !!P.sent;
    go.onclick = submit;
    foot.appendChild(go);
    tray.appendChild(foot);
    return tray;
  }

  function chooserIsHere(m) {
    const pd = m.pending;
    return m.online ? pd.designated === (APP.seat || 0) : humanSeat(m, pd.designated);
  }

  function firstTray(m, P) {
    const pd = m.pending;
    const tray = el("div", "pgtray pgorder");
    if (!chooserIsHere(m)) {
      tray.appendChild(el("div", "msempty", esc("Waiting for " + seatName(m, pd.designated) + " to choose.")));
      return tray;
    }
    if (!m.online && humanSeat(m, 0) && humanSeat(m, 1)) {
      tray.appendChild(el("div", "mslbl", esc(seatName(m, pd.designated) + " chooses")));
    }
    const row = el("div", "pgchoice");
    const play1 = el("button", "btn primary big", "Play first");
    play1.onclick = function () { pickFirst(true); };
    row.appendChild(play1);
    const play2 = el("button", "btn primary big", "Play second");
    play2.title = "The player going second channels an extra rune on their first channel phase (CR 485.7)";
    play2.onclick = function () { pickFirst(false); };
    row.appendChild(play2);
    tray.appendChild(row);
    return tray;
  }

  function seatBand(m, p, mine) {
    const reg = m.registered[p];
    const legend = reg && reg.legend ? window.RB.Setup.findCard(reg.legend) : null;
    const band = el("div", "pgseat " + (mine ? "bot" : "top") + " " + U.pcls(p));
    const tile = el("div", "pgseatart");
    if (legend) U.artStyleCard(tile, legend, "art", 220);
    band.appendChild(tile);
    const text = el("div", "pgseattext");
    text.appendChild(el("div", "pgseatname", esc(seatName(m, p))));
    text.appendChild(el("div", "mslbl", esc(legend ? legend.name : "no legend")));
    band.appendChild(text);
    if (Match.phase(m) === "present") {
      const ready = m.pending.ready[p];
      band.appendChild(el("span", "pgflag " + (ready ? "ok" : "wait"), ready ? "PRESENTED" : "CHOOSING"));
    }
    return band;
  }

  function renderHandoff(m, P) {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const wrap = el("div", "msui");
    wrap.id = "matchscreen";
    wrap.appendChild(el("div", "msweave"));
    const box = el("div", "mspane msbev mthand");
    const inner = el("div", "mspanein msbev");
    inner.appendChild(el("h1", "mtbig", esc(seatName(m, P.seat))));
    inner.appendChild(el("div", "mslbl", "Pass the device — the other seat must not see this choice."));
    const go = el("button", "btn primary big", "I am " + esc(seatName(m, P.seat)));
    go.onclick = function () { P.handoff = false; U.render(); };
    inner.appendChild(go);
    box.appendChild(inner);
    wrap.appendChild(box);
    root.appendChild(wrap);
  }

  function render() {
    const m = APP.match;
    if (!m || !m.pending) { APP.screen = m ? "match" : "menu"; U.render(); return; }
    const P = ensure(m);
    if (P.handoff) { renderHandoff(m, P); return; }

    const me = localSeat(m);
    const opp = me === 0 ? 1 : 0;
    const pd = m.pending;
    const showBf = Match.phase(m) === "turnOrder";

    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "arenaskin";

    const arena = el("div", "pgroot");
    arena.id = "arena";
    const fit = el("div", "arfit");
    const stage = el("div", "arstage");
    stage.id = "arstage";
    stage.appendChild(el("div", "arbg"));
    stage.appendChild(el("div", "argrain"));
    stage.appendChild(el("div", "arveil top " + U.pcls(opp)));
    stage.appendChild(el("div", "arveil bot " + U.pcls(me)));
    stage.appendChild(el("div", "arhorizon"));

    const top = el("div", "pgtop");
    const back = el("button", "btn bbback", "<span>Menu</span>");
    back.onclick = function () {
      if (Match.isMatch(m) && m.games.length && !confirm("Leave this match? The score is lost.")) return;
      if (m.online) { window.RB.Online.go("/play"); return; }
      APP.pregame = null;
      U.clearMatch();
      APP.screen = "menu";
      APP.mode = "play";
      U.render();
    };
    top.appendChild(back);
    const title = el("div", "pgtitle");
    title.appendChild(el("h1", null, Match.isMatch(m) ? "GAME " + m.gameNo : "THE DUEL"));
    const sub = Match.isMatch(m)
      ? Match.label(m) + " · " + seatName(m, 0) + " " + Match.score(m) + " " + seatName(m, 1)
      : seatName(m, 0) + " vs " + seatName(m, 1);
    title.appendChild(el("div", "mslbl", esc(sub)));
    top.appendChild(title);
    stage.appendChild(top);

    stage.appendChild(seatBand(m, opp, false));
    stage.appendChild(seatBand(m, me, true));

    const fields = el("div", "arfields pgfields");
    fields.appendChild(fieldTile(m, opp, showBf ? pd.bf[opp] : null, { hidden: !showBf }));
    fields.appendChild(dial(m, P));
    fields.appendChild(fieldTile(m, me, showBf ? pd.bf[me] : null, { hidden: !showBf }));
    stage.appendChild(fields);

    let tray = null;
    if (P.phase === "present" && !P.sent) tray = selector(m, P);
    else if (P.phase === "present") tray = el("div", "pgtray pgwait", esc("Locked in — waiting for " + seatName(m, P.seat === 0 ? 1 : 0) + "."));
    else if (P.phase === "first") tray = firstTray(m, P);
    if (tray) stage.appendChild(tray);

    const rule = ruleLine(m, P);
    if (rule) (tray || stage).appendChild(el("div", "pgrule", esc(rule)));

    fit.appendChild(stage);
    arena.appendChild(fit);
    root.appendChild(arena);

    if (P.phase === "present" && P.sel) {
      const card = window.RB.Setup.findCard(P.sel);
      const panel = U.cardPanel(card, function () { P.sel = null; U.render(); });
      panel.classList.add("pgview");
      root.appendChild(panel);
    }

    U.fitArena();
  }

  function loadOnline() {
    const m = APP.match;
    if (!m) return;
    const P = ensure(m);
    if (Match.phase(m) === "present") P.sent = !!m.pending.ready[APP.seat || 0];
    step();
  }

  Object.assign(U, {
    renderPregame: render,
    startPregame: start,
    pregameStep: step,
    stagePregameDeck: stageDeck,
    onlinePregame: loadOnline,
  });
})();
